var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdslight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Numbered list"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5 6C5 5.44772 5.44772 5 6 5C6.55228 5 7 5.44772 7 6V9C7 9.55228 6.55228 10 6 10C5.44772 10 5 9.55228 5 9V6Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.35689 14.0656C7.23644 14.0194 7.11032 13.998 6.98538 14H5C4.44772 14 4 14.4477 4 15C4 15.5523 4.44772 16 5 16H5.13158L4.17822 17.43C4.09205 17.5541 4.03323 17.6985 4.01049 17.8546C4.00345 17.9028 3.99998 17.9512 4 17.9994C4 18.1906 4.05367 18.3699 4.14676 18.5218C4.20041 18.6097 4.26832 18.6902 4.34974 18.7597C4.46697 18.8602 4.60771 18.9339 4.76257 18.9716C4.84508 18.9918 4.92913 19.0011 5.01267 19H7C7.55228 19 8 18.5523 8 18C8 17.4477 7.55228 17 7 17H6.86861L7.82858 15.56C7.8603 15.5132 7.88814 15.4636 7.91166 15.4115L7.91706 15.3994C7.99204 15.2278 8.0153 15.0427 7.99092 14.8647C7.9776 14.7662 7.94992 14.6722 7.91007 14.585C7.83903 14.4288 7.72699 14.2891 7.5775 14.1835C7.50972 14.1355 7.4357 14.0957 7.35689 14.0656Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10 5.44772 10.4477 5 11 5H19C19.5523 5 20 5.44772 20 6C20 6.55228 19.5523 7 19 7H11C10.4477 7 10 6.55228 10 6Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 15C10 14.4477 10.4477 14 11 14H19C19.5523 14 20 14.4477 20 15C20 15.5523 19.5523 16 19 16H11C10.4477 16 10 15.5523 10 15Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 8C10.4477 8 10 8.44772 10 9C10 9.55228 10.4477 10 11 10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H11Z",
    fill: "#B2B2B2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18C10 17.4477 10.4477 17 11 17H17C17.5523 17 18 17.4477 18 18C18 18.5523 17.5523 19 17 19H11C10.4477 19 10 18.5523 10 18Z",
    fill: "#B2B2B2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdslight);
export default __webpack_public_path__ + "static/media/adslight.bd1d295cd3531a334e5e518078db57ad.svg";
export { ForwardRef as ReactComponent };